import { Routes, Route, Navigate } from "react-router-dom";
import AuthGuard from "./authGuard";
import NoAuthGuard from "./noAuthGuard";
import Dashboard from "../views/dashboard";
import Login from "../views/auth/login";
import ForgotPassword from "../views/auth/forgotPassword";
import MainLayout from "../components/layout";
import SportsBranches from "../views/sports";
import AgeGroups from "../views/ageGroups";
import Groups from "../views/groups";
import Inventory from "../views/inventory";
import Products from "../views/products";
import Students from "../views/students";
import Packages from "../views/packages";
import Attendance from "../views/attendance";
import { SmsDashboard, SmsTemplates, BulkSms } from '../views/sms';
import Performance from "../views/performance";
import Payments from "../views/payments";
import Reports from "../views/reports";
import AttendanceReport from "../views/reports/attendance-report";
import PackageReport from "../views/reports/package-report";
import EquipmentTracking from "../views/inventory/equipment-tracking";
import Coaches from "../views/coaches";
import CoachAttendance from "../views/attendance/coach-attendance";
import Finance from "../views/finance";
import WpPage from '../views/wp';
import WpSendPage from '../views/wp/send';
import NewsPage from '../views/news';
import ParentsPage from '../views/parents'
import LocationsPage from '../views/locations';
import Notification from '../views/notification';
import PreRegistrations from "../views/preRegistrations";
import Achievements from "../views/achievements";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<NoAuthGuard><Login /></NoAuthGuard>} />
            <Route path="/forgot-password" element={<NoAuthGuard><ForgotPassword /></NoAuthGuard>} />
            <Route path="/select-sport" element={<AuthGuard><SportsBranches /></AuthGuard>} />

            <Route path="/" element={<AuthGuard><MainLayout /></AuthGuard>}>
                <Route index element={<Navigate replace to="/dashboard" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="age-groups" element={<AgeGroups />} />
                <Route path="groups" element={<Groups />} />
                <Route path="students" element={<Students />} />
                <Route path="parents" element={<ParentsPage />} />
                <Route path="packages" element={<Packages />} />
                <Route path="achievements" element={<Achievements />} />
                <Route path="attendance" element={<Attendance />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="equipment-tracking" element={<EquipmentTracking />} />
                <Route path="products" element={<Products />} />
                <Route path="sms" element={<SmsDashboard />} />
                <Route path="sms-templates" element={<SmsTemplates />} />
                <Route path="sms-bulk" element={<BulkSms />} />
                <Route path="performance" element={<Performance />} />
                <Route path="payments" element={<Payments />} />
                <Route path="reports-unpaid" element={<Reports />} />
                <Route path="attendance-report" element={<AttendanceReport />} />
                <Route path="aidat-report" element={<PackageReport />} />
                <Route path="coaches" element={<Coaches />} />
                <Route path="coach-attendance" element={<CoachAttendance />} />
                <Route path="finance" element={<Finance />} />
                <Route path="wp" element={<WpPage />} />
                <Route path="wp-send" element={<WpSendPage />} />
                <Route path="news" element={<NewsPage />} />
                <Route path="locations" element={<LocationsPage />} />
                <Route path="notifications" element={<Notification />} />
                <Route path="pre-registrations" element={<PreRegistrations />} />
            </Route>

            <Route path="*" element={<Navigate replace to="/login" />} />
        </Routes>
    );
};

export default AppRoutes;